import Fuse from 'fuse.js'

const fuseOptions = {
  shouldSort: true,
  ignoreDiacritics: false,
  isCaseSensitive: false
}

const ACCEPTED_SCORE = 0.4 as const

/**
 * Simple version of the fuzzy search algorithm.
 *
 * @param options - should be the array of objects you want to search in.
 * @param keysToSearch - should be the array of keys you want to search in. If you're sending a basic string[], keysToSearch should be empty.
 * @param validScore - At what point does the match algorithm give up. A threshold of 0.0 requires a perfect match (of both letters and location), a threshold of 1.0 would match anything.
 *
 * @returns The array of objects that match the search
 */
export function fuzzySearch<T>({
  search,
  options,
  keysToSearch,
  validScore = ACCEPTED_SCORE
}: {
  search: string
  options: readonly T[]
  keysToSearch: string[]
  validScore?: number
}) {
  const result = new Fuse(options, {
    ...fuseOptions,
    threshold: validScore,
    keys: keysToSearch
  }).search(search)

  return result.map(i => i.item)
}
